import React, {useState} from 'react';
import PropTypes from 'prop-types';
import styled from "@emotion/styled";

const ComponentWrapper = styled.div`
    width: fit-content;
`;

const GroupHeadingWrapper = styled.div`
     display: flex;
     justify-content: space-between;
     flex-direction: row;
     align-items: center;
     margin-bottom: 24px;
`;


const Seen = styled.div`
    width: 12px;
    height: 12px;
    margin-right: 8px;
    
    /* default/green/400 */
    background: #68D391;
    border-radius: 12px;
    box-shadow: 0 2px 10px rgba(104, 211, 145, 0.3);
`;

const GroupHeading = styled.div`
    display: flex;
    flex-direction: row;
`;

const CollapseButton = styled.div`
    width: 150px;
    height: 20px;
    
    justify-content: center;
    align-items: center;
    
    font-family: Metropolis;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 12px;
    /* identical to box height */
    display: flex;
    align-items: center;
    
    /* default/blue/600 */
    color: var(--color-blue-600);
    
    cursor: pointer;
    user-select: none;
    
    /* default/gray/200 */
    background: #EEF2F6;
    /* default/gray/400 */
    border: 1px solid #CCD6E0;
    box-sizing: border-box;
    border-radius: 4px;
`;

const NotificationsWrapper = styled.div`
    position: relative;
    width: 560px;
    height: fit-content;
    min-height: 200px;
    
    //display: grid;
    //grid-auto-flow: row;
    //grid-row-gap: 24px;
    
    display: flex;
    flex-direction: column;
    
    align-items: center;    
`;

function AlertsCardsGroup(props) {
    const { heading, seen, collapsible } = props;

    const [collapsed, setCollapsed] = useState(true);

    return (
        <ComponentWrapper>
            <GroupHeadingWrapper>
                <GroupHeading>
                    { !seen && <Seen/> }
                    {heading}
                </GroupHeading>
                <div>
                    {
                        collapsible &&
                        <CollapseButton onClick={() => setCollapsed(!collapsed)}>
                            {
                                (collapsed) ? "Expand Category" : "Collapse Category"
                            }
                        </CollapseButton>
                    }
                </div>
            </GroupHeadingWrapper>

            <NotificationsWrapper>
                {
                    props.render(collapsed)
                }
            </NotificationsWrapper>
        </ComponentWrapper>
    );
}

AlertsCardsGroup.propTypes = {
    heading: PropTypes.string.isRequired,
    seen: PropTypes.bool.isRequired,
    collapsible: PropTypes.bool.isRequired,
};

AlertsCardsGroup.defaultProps = {
    heading: "Alerts",
    seen: false,
    collapsible: false
};

export default AlertsCardsGroup;
